export const getAppointmentsFilters = state => {
  const {
    appointmentStatuses,
    dateRange,
    lastConversationStatuses,
    scheduleTypes,
    isGroupAppointment,
    services,
    consultationTypes,
    conversationTypes,
  } = state.queues.schedule.appointmentsFilters;

  const filters = {};

  if (dateRange.startDate) {
    filters.date = {
      ...filters.date,
      from: dateRange.startDate.getTime(),
      type: dateRange.type,
    };
  }

  if (dateRange.endDate) {
    filters.date = {
      ...filters.date,
      to: dateRange.endDate.getTime(),
      type: dateRange.type,
    };
  }

  if (lastConversationStatuses.length) filters.lastConversationStatuses = lastConversationStatuses;
  if (appointmentStatuses.length) filters.appointmentState = appointmentStatuses;
  if (services.length) filters.serviceIds = services;
  if (scheduleTypes.length) filters.appointmentServiceQueueType = scheduleTypes;
  if (isGroupAppointment.length === 1) {
    filters.isGroupAppointment = isGroupAppointment.includes('YES');
  }
  if (consultationTypes.length) filters.consultationTypes = consultationTypes;
  if (conversationTypes.length) filters.conversationTypes = conversationTypes;

  return filters;
};
